/**
 * Returns true if received parameter null
 * @param x
 * @returns
 *
 * @example
 * // given
 * const x = [1,null,3,undefined]
 * const nulls = [undefined,null]
 * // when
 * x.filter(isNull)    // [undefined,null]
 * nulls.some(isNull)  // true
 * nulls.every(isNull) // true
 * x.some(isNull)      // true
 * x.every(isNull)     // false
 */
export const isNull = (...items: any[]) => items.every(x => x == null);
